// Formatierung der Handlungsbedarf-Zähler für die Navigations-Badges. Bewusst
// React-frei und OHNE Import aus NavigationLayout: die MobileBottomNav wird von
// NavigationLayout importiert (NavigationLayout → MobileBottomNav), sodass ein
// Helper AUS NavigationLayout einen Zirkularimport erzeugen würde. Beide Leisten
// (Desktop/Tablet-Sidebar via NavRow + Phone-Bottom-Leiste) teilen sich daher
// diese eigenständige Quelle für die Zahl→Pille-Kappung.

/**
 * Formatiert einen Badge-Zähler zur Anzeige in einer Nav-Pille und kappt große
 * Werte auf „99+", damit die Pille kompakt bleibt.
 *
 * - `n` ≤ 0, kein `number` oder nicht endlich → `null` (kein Badge rendern).
 * - `n` > 99 → `"99+"` (3 Zeichen; Aufrufer verkleinert dann die Schrift und
 *   verankert die breitere Pille mittig).
 * - sonst die abgerundete Ganzzahl als String.
 */
export function fmtBadge(n: number | null | undefined): string | null {
  if (typeof n !== "number" || !Number.isFinite(n) || n <= 0) return null;
  return n > 99 ? "99+" : String(Math.floor(n));
}
